const firstSection = document.querySelector('main .shopify-section');

function updateBackgroundParallax() {
  const windowHeight = window.innerHeight;

  const parallaxElements = document.querySelectorAll('.js-parallax-background-item img, .js-parallax-background-item video');

  if (window.innerWidth <= 991) {
    parallaxElements.forEach(el => el.style.transform = 'translateY(0px)');
    return;
  }

  parallaxElements.forEach(element => {
    const parent = element.closest('.js-parallax-background-item');
    if (!parent) return;

    const section = element.closest('.shopify-section');
    const isInFirstSection = section === firstSection;

    let isFirstItemInSection = false;
    if (isInFirstSection) {
      const allInSection = section.querySelectorAll('.js-parallax-background-item');
      isFirstItemInSection = allInSection[0] === parent;
    }

    const treatAsFirstSection = isInFirstSection && isFirstItemInSection;

    const rect = parent.getBoundingClientRect();
    const isVisible = rect.bottom > 0 && rect.top < windowHeight;
    if (!isVisible) return;

    let progress, offset;

    if (treatAsFirstSection) {
      progress = Math.min(1, Math.max(0, -rect.top / rect.height));
      offset = progress * 150;
    } else {
      progress = Math.min(1, Math.max(0, (windowHeight / 2 - rect.top) / (windowHeight + rect.height)));
      offset = -100 + (250 * progress);
    }

    element.style.transform = `translateY(${Math.round(offset)}px)`;
  });
}

window.addEventListener('scroll', updateBackgroundParallax);
window.addEventListener('load', updateBackgroundParallax);
window.addEventListener('resize', updateBackgroundParallax);

function initParallax() {
  const items = document.querySelectorAll('.js-parallax-item:not(.active)');
  const maxOffset = 70;

  function throttle(callback, limit) {
    let waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(() => (waiting = false), limit);
      }
    };
  }

  function handleScroll() {
    const windowHeight = window.innerHeight;

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const visibleThreshold = windowHeight * 0.5;
      const start = windowHeight;
      const progress = Math.min(1, Math.max(0, (start - rect.top) / visibleThreshold));

      let offset = window.innerWidth < 991 
        ? 40 * (1 - progress) 
        : (parseFloat(item.dataset.offset) || maxOffset) * (1 - progress);
      
      item.style.transform = `translateY(${Math.max(offset, 0)}px)`;
      item.classList.add('active');
    });
  }

  const throttledScroll = throttle(handleScroll, 16);

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          handleScroll();
          window.addEventListener('scroll', throttledScroll);
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '100px',
    }
  );

  items.forEach((item) => observer.observe(item));
  handleScroll();
}

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth > 991) {
    initParallax();
  }
});